import React from 'react';

import { ReactComponent as FacebookIcon } from './icons/facebook.svg';
import { ReactComponent as InstagramIcon } from './icons/instagram.svg';
import { ReactComponent as LinkTreeIcon } from './icons/linktree.svg';
import { ReactComponent as PatreonIcon } from './icons/patreon.svg';
import { ReactComponent as SoundCloudIcon } from './icons/soundcloud.svg';
import { ReactComponent as SpotifyIcon } from './icons/spotify.svg';
import { ReactComponent as TikTokIcon } from './icons/tiktok.svg';
import { ReactComponent as TwitchIcon } from './icons/twitch.svg';
import { ReactComponent as TwitterIcon } from './icons/twitter.svg';
import { ReactComponent as WebsiteIcon } from './icons/web.svg';
import { ReactComponent as YouTubeIcon } from './icons/youtube.svg';
import { onServer } from '../../api';

const icons = {
	facebook: <FacebookIcon />,
	instagram: <InstagramIcon />,
	youtube: <YouTubeIcon />,
	patreon: <PatreonIcon />,
	tiktok: <TikTokIcon />,
	soundcloud: <SoundCloudIcon />,
	spotify: <SpotifyIcon />,
	twitter: <TwitterIcon />,
	twitch: <TwitchIcon />,
	website: <WebsiteIcon />,
	linktree: <LinkTreeIcon />,
};

export default function Icon({ name }) {
	if (onServer()) return null;
	return icons[name] || null;
}
